import { render, staticRenderFns } from "./ConsultingSettingsList.vue?vue&type=template&id=ed955f2c"
import script from "./ConsultingSettingsList.vue?vue&type=script&lang=js"
export * from "./ConsultingSettingsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports